import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GetExtensionDetail_extension_extensionAutoAttendant } from '../../queries/generated/GetExtensionDetail';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-extension-auto-attendant-detail-left-column',
    styleUrls: [
        './extension-auto-attendant-detail-left-column.component.scss',
        '../extension-detail-view.component.scss',
    ],
    templateUrl: './extension-auto-attendant-detail-left-column.component.html',
    standalone: false
})
export class ExtensionAutoAttedantDetailLeftColumnComponent {
   @Input() extensionAutoAttendant: GetExtensionDetail_extension_extensionAutoAttendant | null;
}
